import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { SLICE_KEYS } from '../SliceKeys'
import { IContractSignState, ISetVerificationCodeInputValueAction, TVerificationCodeInputsNamesModel, verificationCodeInputsNames } from './ContractSignModels'
import { submitSmsCodeAgainThunkAction } from './middleware/ContractSignThunkActions'


export enum SMS_CODE_STATUSES {
   LIMIT_REACHED,
   CODE_SEND_CORRECTLY,
   SEND_ERROR,
   VALIDATION_ERROR_FULL_CODE_REQUIRED,
   VALIDATION_ERROR_WRONG_CODE,
   VALIDATION_ERROR_CLIENT_PESEL_RESERVED,
}

export const initialContractSignState: IContractSignState = {
   verificationCodeInputs: {
      [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_1]: '',
      [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_2]: '',
      [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_3]: '',
      [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_4]: '',
      [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_5]: '',
      [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_6]: '',
   },

   sendCodeSmsStatus: {
      isLimit : false,
      hasError : false,
      sendedSmsCount: 0,
   },

   currentFullSmsCode: null,
   agreemenFileName: '',
   currentSmsCodeTextState: null,
   currentClientPeselReservedErrorText: null,
}


export const contractSignSlice = createSlice({
   name: SLICE_KEYS.CONTRACT_SIGN_SLICE,
   initialState: initialContractSignState,
   reducers: {
      setVerificationCodeInputValue: (state, action: PayloadAction<ISetVerificationCodeInputValueAction>) => {
         state.verificationCodeInputs[action.payload.inputName] = action.payload.newValue
      },
      resetVerificationCodeForm: (state) => {
         const newState = state

         Object.values(verificationCodeInputsNames).forEach((verificationCodeName: TVerificationCodeInputsNamesModel) => {
            newState.verificationCodeInputs[verificationCodeName] = ''
         })

         state = newState
      },
      smsCodeSubbmited: (state, action: PayloadAction<boolean>) => {
         state.sendCodeSmsStatus.isLimit = action.payload
      },
      submitSmsCodeAgain: (state) => {
         state.sendCodeSmsStatus.sendedSmsCount = state.sendCodeSmsStatus.sendedSmsCount + 1
      },
      setSendSmsCodeValidationError: (state, action: PayloadAction<SMS_CODE_STATUSES>) => {
         state.sendCodeSmsStatus.hasError = true
         state.currentSmsCodeTextState = action.payload
      },
      setAgreementFileName: (state, action: PayloadAction<string>) => {
         state.agreemenFileName = action.payload
      },
      setCurrentFullSmsCode: (state, action: PayloadAction<string>) => {
         if(action.payload.length === Object.keys(state.verificationCodeInputs).length){
            state.currentFullSmsCode = action.payload
         }
      },
      setCurrentClientPeselReservedErrorText: (state, action: PayloadAction<string>) => {
         state.currentClientPeselReservedErrorText = action.payload
      },
   },
   extraReducers: (builder) => {
      builder.addCase(submitSmsCodeAgainThunkAction.fulfilled, (state, action) => {
        if(action.payload !== undefined){
            state.sendCodeSmsStatus.isLimit = action.payload.isLimit
            
            if(action.payload.isLimit === false) {
               state.sendCodeSmsStatus.hasError = false
               state.currentSmsCodeTextState = SMS_CODE_STATUSES.CODE_SEND_CORRECTLY
            }
            else {
               state.sendCodeSmsStatus.hasError = true
               state.currentSmsCodeTextState =  SMS_CODE_STATUSES.LIMIT_REACHED
            }
         }
      })
      builder.addCase(submitSmsCodeAgainThunkAction.rejected, (state) => {
         state.sendCodeSmsStatus.hasError = true
         state.currentSmsCodeTextState =  SMS_CODE_STATUSES.SEND_ERROR
       })
    }  
 })
 
 // Action creators are generated for each case reducer function
 export const { 
   setVerificationCodeInputValue, 
   setAgreementFileName, 
   resetVerificationCodeForm, 
   smsCodeSubbmited, 
   submitSmsCodeAgain, 
   setSendSmsCodeValidationError,
   setCurrentFullSmsCode,
   setCurrentClientPeselReservedErrorText,
 } = contractSignSlice.actions
 
 export default contractSignSlice.reducer